module.exports = __webpack_public_path__ + "static/ultra-f8240d2a0635ff2034d8e06e9ba0d662.jpg";